exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Collection__collectionLIST___Ec2Me {\n\tmargin: 0;\n\toverflow: hidden;\n\tflex: 1;\n}\n\n.Collection__collectionGRID___2OEdp {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n}\n\n.Collection__collectionGRID___2OEdp .Collection__borderBottom___zVB6P {\n\tdisplay: none;\n}\n\n.Collection__borderBottom___zVB6P {\n\tborder-bottom: solid 1px #ccc;\n\theight: 1px;\n}\n", ""]);

// exports
exports.locals = {
	"collectionLIST": "Collection__collectionLIST___Ec2Me",
	"collectionGRID": "Collection__collectionGRID___2OEdp",
	"borderBottom": "Collection__borderBottom___zVB6P"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Collection.icss
// module id = 1329
// module chunks = 0